import { PinakesService } from '@/services/pinakes/pinakes';
import type { TPinakesCard, TPinakesGroupDetail, TPinakesResourceDetail } from '@/services/pinakes/pinakes.types';

/**
 * External resource cards from Pinakes. Network only: a card enriches a link the way its Open
 * Graph preview does, so nothing is written to IndexedDB.
 */
export class PinakesApplication {
  private constructor() {}

  /** One link's card, or `null` when Pinakes has none (or is not configured). */
  static fetchCardByUri(uri: string): Promise<TPinakesResourceDetail | null> {
    return PinakesService.fetchCardByUri(uri);
  }

  /** What the people who tagged the resource also referenced. */
  static fetchRelated(id: string, limit: number): Promise<TPinakesCard[]> {
    return PinakesService.fetchRelated(id, limit);
  }

  /** A group's member cards, or `null` when the group is gone (or Pinakes is not configured). */
  static fetchGroup(id: string): Promise<TPinakesGroupDetail | null> {
    return PinakesService.fetchGroup(id);
  }
}
